import { type FC, Suspense } from 'react';
import { Outlet } from 'react-router';

import SuspenseFallback from './suspense-fallback';

const SuspenseRoute: FC = () => {
  return (
    <Suspense fallback={<SuspenseFallback />}>
      <Outlet />
    </Suspense>
  );
};

export default SuspenseRoute;
